import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

import ChartKick from 'vue-chartkick'
import Chart from 'chart.js'

import './plugins/axios'

Vue.use(ChartKick.use(Chart))

Vue.config.productionTip = false

//Filtro para ajuste de valor monetario
Vue.filter('dinheiro', valor => {

  return `${valor.toLocaleString('pt-br', { minimumFractionDigits: 2 })}`
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
